import { Typography } from "@mui/material";
import React from 'react';

const About = () => (
  <div>
    <Typography variant="h4" gutterBottom>Welcome to About Page</Typography>
    <Typography>This is the About Page content.</Typography>
  </div>
);

export default About;
